import type { Status } from "../lib/types-explorer";

interface Props {
  status: Status | null;
  onSet: (next: Status | null) => void;
}

export function StatusButtons({ status, onSet }: Props) {
  const stop = (e: React.MouseEvent) => e.stopPropagation();
  return (
    <fieldset className="flex gap-2" aria-label="Approve or veto">
      <button
        type="button"
        className={`flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-md font-medium text-[12px] border transition-colors ${
          status === "approved"
            ? "bg-(--color-ok) border-(--color-ok) text-(--color-paper)"
            : "bg-(--color-paper) border-(--color-line) text-(--color-ink-2) hover:border-(--color-ink-3) hover:text-(--color-ink)"
        }`}
        aria-pressed={status === "approved"}
        onClick={(e) => {
          stop(e);
          onSet(status === "approved" ? null : "approved");
        }}
      >
        <span className="text-[13px] font-bold">✓</span> Approve
      </button>
      <button
        type="button"
        className={`flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-md font-medium text-[12px] border transition-colors ${
          status === "vetoed"
            ? "bg-(--color-bad) border-(--color-bad) text-(--color-paper)"
            : "bg-(--color-paper) border-(--color-line) text-(--color-ink-2) hover:border-(--color-ink-3) hover:text-(--color-ink)"
        }`}
        aria-pressed={status === "vetoed"}
        onClick={(e) => {
          stop(e);
          onSet(status === "vetoed" ? null : "vetoed");
        }}
      >
        <span className="text-[13px] font-bold">✕</span> Veto
      </button>
    </fieldset>
  );
}
